<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <geneltiplist
          :etiket="$t('Withholding-Code')"
          :listetip="'302'"
          v-model="val.TutarBilgileri.TevkifatTutar.TevkifatKodu"
        >
        </geneltiplist>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <v-select
          :items="tevkifatList"
          item-text="text"
          hide-details=""
          item-value="value"
          clearable=""
          :label="$t('Withholding-VAT')"
          v-model="val.TutarBilgileri.TevkifatTutar.TevkifatOran"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <parainput
          v-if="isUpdate"
          :isPositive="true" 
          :simge="getparabirimi()"
          :aktif="'false'"
          :etiket="'Tev. KDV Tutar'"
          :autocomplete="'autocomplete'"
          v-model="val.TutarBilgileri.TevkifatTutar.TevkifatTutar"
        ></parainput>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <span class="caption">*  {{ $t('VAT-calculated-after-registration') }} </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import geneltiplist from "@/components/app/customcomp/geneltiplist.vue";
import parainput from "@/components/app/customcomp/parainput";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  name: "tekvifat",
  props: {
    value: {
      type: Object,
    },
    isUpdate: {
      type: Boolean,  
    },
  },
  components: {
    geneltiplist,
    parainput,
  },
  computed: {
    val: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    getparabirimi() {
      return helpers.getparabirimi();
    },
  },
  data() {
    return {
      tevkifatList: [
        {
          text: "0/10",
          value: 0,
        },
        {
          text: "1/10",
          value: 0.1,
        },
        {
          text: "2/10",
          value: 0.2,
        },
        {
          text: "3/10",
          value: 0.3,
        },
        {
          text: "4/10",
          value: 0.4,
        },
        {
          text: "5/10",
          value: 0.5,
        },
        {
          text: "6/10",
          value: 0.6,
        },
        {
          text: "7/10",
          value: 0.7,
        },
        {
          text: "8/10",
          value: 0.8,
        },
        {
          text: "9/10",
          value: 0.9,
        },
        {
          text: "10/10",
          value: 1,
        },
      ],
    };
  },
};
</script>

<style></style>
